import type { EnumUnion } from '@dresscode-frontend/utility-types';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { Spacer, VStack } from '@/components/Layout';
import { CsvUploadOption } from './-components/CsvUploadOption';
import { Header } from './-components/Header';
import { PublicIdTypeRadioGroup } from './-components/PublicIdTypeRadioGroup';
import { SyncItOption } from './-components/SyncItOption';
import { PublicIdType } from './-constants/publicIdType';
export const Route = createFileRoute('/_staff/public-ids/add/')({
  component: Introduce
});
function Introduce() {
  const [selectedPublicIdType, setSelectedPublicIdType] = useState<EnumUnion<typeof PublicIdType>>(PublicIdType.NATIONAL_ID);
  return <VStack className="mx-auto w-[1000px] ">
      <Spacer variant="xxl" />
      <Header />
      <Spacer variant="xxl" />
      <PublicIdTypeRadioGroup selectedPublicIdType={selectedPublicIdType} onValueChange={setSelectedPublicIdType} />
      <Spacer variant="xxl" />
      <SyncItOption />
      <Spacer variant="l" />
      <CsvUploadOption selectedPublicIdType={selectedPublicIdType} />
    </VStack>;
}